// export const caseStudies = [
//   {
//     title: "My Outdoor TV",
//     year: "2016",
//     description:
//       "Watch whatever you want anytime from our catalog of thousands of hunting, fishing & shooting episodes – featuring the biggest names in outdoor TV like Franz-Albrecht Oettingen-Spielberg, Mikael Tham, Jim Shockey, Ulf Lindroth, Kristoffer Clausen, and Feliew Chasse.",
//     technologies: [
//       { name: "Swift", icon: "/images/icons/swift.webp" },
//       { name: "Kotlin", icon: "/images/icons/kotlin.webp" },
//       { name: "Node JS", icon: "/images/icons/nodejs.webp" },
//     ],
//     image: "/images/caseStudiesImages/Movo_db_new.webp",
//     website: "https://myoutdoortv.com/",
//   },
//   {
//     title: "NEOU",
//     year: "2018",
//     description:
//       "Discover the NEW YOU with at-home and on-the-go fitness reimagined! Workout anytime, anywhere with thousands of live and on-demand classes from 100+ world-class instructors and fitness studios. Free trial for new members.",
//     technologies: [
//       { name: "Design", icon: "/images/icons/figma.webp" },
//       { name: "HTML 5/CSS 3", icon: "/images/icons/html5.webp" },
//       { name: "Javascript", icon: "/images/icons/javascript.webp" },
//       { name: "Jquery", icon: "/images/icons/jquery.webp" },
//       { name: "Bootstrap", icon: "/images/icons/bootstrap.webp" },
//       { name: "Php", icon: "/images/icons/php.webp" },
//     ],
//     image: "/images/caseStudiesImages/Neou App Banner.webp",
//     website: "https://neoufitness.com/",
//   },
//   {
//     title: "Ease My Trip",
//     year: "2018",
//     description:
//       "EaseMyTrip is a booking application, which is for the guaranteed best price on travel. At EaseMyTrip, you can search holiday packages, book flights and plan your travel. Book cheap flights, bus tickets, hotels and holiday packages with us and enjoy. Being a reputed name in the travel industry of India, we provide attractive offers on travel through our flight tickets booking app.",
//     technologies: [
//       { name: "Swift", icon: "/images/icons/swift.webp" },
//       { name: "Kotlin", icon: "/images/icons/kotlin.webp" },
//     ],
//     image: "/images/caseStudiesImages/ease_my_trip_new.webp",
//     website: "http://www.easemytrip.com/",
//   },
//   {
//     title: "IITIIMShadi.com",
//     year: "2018",
//     description:
//       "Exclusive Lounge to Explore Matrimonial Alliance Among Alumni of Premier Educational Institutions. We now have members in India and 50 other countries. One of the biggest differentiators of our website, other than its niche segment, is that we authenticate each profile on the basis of education by screening their institution’s degree, ID-card/mark sheet etc.",
//     technologies: [
//       { name: "Swift", icon: "/images/icons/swift.webp" },
//       { name: "CodeIgniter", icon: "/images/icons/codeigniter.webp" },
//       { name: "Kotlin", icon: "/images/icons/kotlin.webp" },
//     ],
//     image: "/images/caseStudiesImages/iitm_new.webp",
//     website: "http://www.iitiimshaadi.com/",
//   },
//   {
//     title: "100MB",
//     year: "2018",
//     description:
//       "100MB: The Ultimate Digital Destination for Cricket Fans crafted by Sachin Tendulkar! Discover an exciting new way of following cricket, only on 100MB. Win big while you follow your favourite game. From live scores, latest cricket news & videos to Free Fantasy & Cricket Tambola – 100MB is your one-stop shop for all things cricket!",
//     technologies: [
//       { name: "Swift", icon: "/images/icons/swift.webp" },
//       { name: "PHP", icon: "/images/icons/php.webp" },
//     ],
//     image: "/images/caseStudiesImages/100 MB Banner.webp",
//     website: "https://www.100mbapp.com/",
//   },
//   {
//     title: "Recon-3D",
//     year: "2018",
//     description:
//       "Recon-3D is a scanning application that fuses photogrammetry and the lidar sensor on the iPhone/iPad Pro. The data can be processed on the cloud or in case of sensitive data, directly on the device only with no data transmitted over the internet. The app provides optional scaling via April Tags which immediately adjusts the scale of the 3D model to match real-world reference measurements. The data can be exported to other programs for inspection, analysis and visualization in e57 format.",
//     technologies: [
//       { name: "Swift", icon: "/images/icons/swift.webp" },
//       { name: "ARKit", icon: "/images/icons/arkit22.webp",  },
//       { name: "PHP", icon: "/images/icons/php.webp" },
//     ],
//     image: "/images/caseStudiesImages/Recon 3D Banner.webp",
//     website: "https://www.recon-3d.com/",
//   },
//   {
//     title: "RightLife: Health Tracker",
//     year: "2018",
//     description:
//       "Your health. Your habits. One intelligent app to track them all.RightLife is your all-in-one health tracker for better sleep, balanced nutrition, stress management, daily movement, and more. Whether you use a wearable or go device-free, RightLife brings together science, technology, and habit-building to help you improve how you eat, move, sleep, and feel. Track What Matters.",
//     technologies: [
//       { name: "Swift", icon: "/images/icons/swift.webp" },
//       { name: "Kotlin", icon: "/images/icons/kotlin.webp" },
//       { name: "Typescript", icon: "/images/icons/typescript.webp" },
//     ],
//     image: "/images/caseStudiesImages/Rightlife Banner.webp",
//     website: "https://rightlife.com/",
//   },
//   {
//     title: "ImWOW",
//     year: "2018",
//     description:
//       "I’MWOW is an online fitness and nutrition community. Just like many others, I’MWOW started its journey as a WhatsApp group that used to help people achieve their fitness goals. Today, it is one of India’s topmost engaging and informative fitness communities with members across nations.I’MWOW was founded in October 2019 by Gunjan Taneja, a fitness influencer and enthusiast. In her words, she is on a mission to make people believe that fitness can be achieved by anyone. Let’s not get stuck between the extremes of body positivity and body shaming and focus on what is actually good for your body.",
//     technologies: [
//       { name: "React Native", icon: "/images/icons/reactnative.webp" },
//       { name: "Node", icon: "/images/icons/nodejs.webp" },
//       { name: "PHP", icon: "/images/icons/php.webp" },
//     ],
//     image: "/images/caseStudiesImages/Imwow Banner.webp",
//     website: "https://www.imwow.co.in/",
//   },
//   {
//     title: "Tracer",
//     year: "2018",
//     description:
//       "Tracer (Hike Shoe Pvt. Ltd.) is not just a shoe brand; it's a story of resilience and commitment that started over 23 years ago. Our founder, Mr. Nitin Kohli, started the brand with a simple yet powerful vision - to create a comfortable, stylish, and high-quality product line for the common man. He believed that everyone deserved to have access to premium footwear that didn't break the bank. And so, he set out to create a brand that would make his vision a reality.",
//     technologies: [
//       { name: "React Native", icon: "/images/icons/reactnative.webp" },
//       { name: "Node", icon: "/images/icons/nodejs.webp" },
//       { name: "PHP", icon: "/images/icons/php.webp" },
//     ],
//     image: "/images/caseStudiesImages/Tracer_Banner_N.webp",
//     website: "https://www.tracerindia.com/",
//   },
// ];

export const caseStudies = {
  projects: {
    liveProjects: [
      {
        "title": "My Outdoor TV",
        "year": 2016,
        "status": "live",
        "description": "Watch whatever you want anytime from our catalog of thousands of hunting, fishing & shooting episodes – featuring the biggest names in outdoor TV like Franz-Albrecht Oettingen-Spielberg, Mikael Tham, Jim Shockey, Ulf Lindroth, Kristoffer Clausen, and Feliew Chasse.",
        "bannerImage": "http://139.59.37.14:4200/uploads/1779881862212-Movo_db_new.webp",
        "websiteUrl": "https://myoutdoortv.com/",
        "technologies": [
          {
            "name": "Swift",
            "icon": "http://139.59.37.14:4200/uploads/1779881863309-swift.webp"
          },
          {
            "name": "Kotlin",
            "icon": "http://139.59.37.14:4200/uploads/1779881863353-kotlin.webp"
          },
          {
            "name": "Node JS",
            "icon": "http://139.59.37.14:4200/uploads/1779881863398-nodejs.webp"
          }
        ],
        "priority": 1,
        "platforms": "Mobile",
        "category": "Non-Gov",
        "subCategory": "Fitness",
        "projectImages": [
          "http://139.59.37.14:4200/uploads/1779881862373-siraj-alam-cm4G9l8tGnI-unsplash.jpg",
          "http://139.59.37.14:4200/uploads/1779881862601-jyoti-singh-evtL96IfR2E-unsplash.jpg",
          "http://139.59.37.14:4200/uploads/1779881862837-chad-madden-SUTfFCAHV_A-unsplash.jpg"
        ],
        "projectOverview": "<p><strong>ADDENDUM NO. 1</strong></p><p><strong>to the Service Agreement dated 5.6.2024 („Service Agreement“)<br>between<br>Etulintu s.r.o., with offices at Ondříčkova 1270/25, Žižkov, 130 00 Prague 3, Czech Republic (“Client”)</strong></p>"
      },
      {
        "title": "NEOU",
        "year": 2018,
        "status": "live",
        "description": "Discover the NEW YOU with at-home and on-the-go fitness reimagined! Workout anytime, anywhere with thousands of live and on-demand classes from 100+ world-class instructors and fitness studios. Free trial for new members.",
        "bannerImage": "http://139.59.37.14:4200/uploads/1779882419952-Neou App Banner.webp",
        "websiteUrl": "https://neoufitness.com/",
        "technologies": [
          {
            "name": "Design",
            "icon": "http://139.59.37.14:4200/uploads/1779882420835-figma.webp"
          },
          {
            "name": "HTML 5/CSS 3",
            "icon": "http://139.59.37.14:4200/uploads/1779882420877-html5.webp"
          },
          {
            "name": "Javascript",
            "icon": "http://139.59.37.14:4200/uploads/1779882420922-javascript.webp"
          }
        ],
        "priority": 1,
        "platforms": "Mobile",
        "category": "Non-Gov",
        "subCategory": "Fintech",
        "projectImages": [],
        "projectOverview": ""
      },
      {
        "title": "Ease My Trip",
        "year": 2018,
        "status": "live",
        "description": "EaseMyTrip is a booking application, which is for the guaranteed best price on travel. At EaseMyTrip, you can search holiday packages, book flights and plan your travel. Book cheap flights, bus tickets, hotels and holiday packages with us and enjoy.",
        "bannerImage": "http://139.59.37.14:4200/uploads/1779882076343-ease_my_trip_new.webp",
        "websiteUrl": "http://www.easemytrip.com/",
        "technologies": [
          {
            "name": "Swift",
            "icon": "http://139.59.37.14:4200/uploads/1779882077211-swift.webp"
          },
          {
            "name": "Kotlin",
            "icon": "http://139.59.37.14:4200/uploads/1779882077252-kotlin.webp"
          }
        ],
        "priority": 1,
        "platforms": "Mobile",
        "category": "Non-Gov",
        "subCategory": "Fintech",
        "projectImages": [],
        "projectOverview": ""
      },
      {
        title: "Imwow",
        slug: "imwow",
        year: 2026,
        status: "live",
        description: "Imwow is a health and fitness project.",
        bannerImage:
          "http://139.59.37.14:4200/uploads/1779878108234-Screenshot 2026-05-27 115349.png",
        websiteUrl: "https://www.imwow.co.in/",
        technologies: [
          {
            name: "React Native",
            icon: "http://139.59.37.14:4200/uploads/1779878108544-rwacticon.webp",
          },
          {
            name: "Typescript",
            icon: "http://139.59.37.14:4200/uploads/1779878108593-typescript.webp",
          },
        ],
        priority: 1,
        platforms: "Mobile",
        category: "Non-Gov",
        subCategory: "Fitness",
        projectImages: [],
        projectOverview: "",
      },
      {
        "title": "My Outdoor TV (2)",
        "year": 2016,
        "status": "live",
        "description": "Watch whatever you want anytime from our catalog of thousands of hunting, fishing & shooting episodes.",
        "bannerImage": "http://139.59.37.14:4200/uploads/1779881862212-Movo_db_new.webp",
        "websiteUrl": "https://myoutdoortv.com/",
        "technologies": [
          {
            "name": "Swift",
            "icon": "http://139.59.37.14:4200/uploads/1779881863309-swift.webp"
          }
        ],
        "priority": 1,
        "platforms": "Mobile",
        "category": "Non-Gov",
        "subCategory": "Fitness",
        "projectImages": [],
        "projectOverview": ""
      },
      {
        "title": "NEOU (2)",
        "year": 2018,
        "status": "live",
        "description": "Discover the NEW YOU with at-home and on-the-go fitness reimagined!",
        "bannerImage": "http://139.59.37.14:4200/uploads/1779882419952-Neou App Banner.webp",
        "websiteUrl": "https://neoufitness.com/",
        "technologies": [
          {
            "name": "Design",
            "icon": "http://139.59.37.14:4200/uploads/1779882420835-figma.webp"
          }
        ],
        "priority": 1,
        "platforms": "Mobile",
        "category": "Non-Gov",
        "subCategory": "Fintech",
        "projectImages": [],
        "projectOverview": ""
      },
      {
        "title": "Ease My Trip (2)",
        "year": 2018,
        "status": "live",
        "description": "EaseMyTrip is a booking application, which is for the guaranteed best price on travel.",
        "bannerImage": "http://139.59.37.14:4200/uploads/1779882076343-ease_my_trip_new.webp",
        "websiteUrl": "http://www.easemytrip.com/",
        "technologies": [
          {
            "name": "Swift",
            "icon": "http://139.59.37.14:4200/uploads/1779882077211-swift.webp"
          }
        ],
        "priority": 1,
        "platforms": "Mobile",
        "category": "Non-Gov",
        "subCategory": "Fintech",
        "projectImages": [],
        "projectOverview": ""
      },
      {
        title: "Imwow (2)",
        slug: "imwow-2",
        year: 2026,
        status: "live",
        description: "Imwow is a health and fitness project.",
        bannerImage:
          "http://139.59.37.14:4200/uploads/1779878108234-Screenshot 2026-05-27 115349.png",
        websiteUrl: "https://www.imwow.co.in/",
        technologies: [
          {
            name: "React Native",
            icon: "http://139.59.37.14:4200/uploads/1779878108544-rwacticon.webp",
          }
        ],
        priority: 1,
        platforms: "Mobile",
        category: "Non-Gov",
        subCategory: "Fitness",
        projectImages: [],
        projectOverview: "",
      },
      {
        "title": "My Outdoor TV (3)",
        "year": 2016,
        "status": "live",
        "description": "Watch whatever you want anytime from our catalog of thousands of hunting, fishing & shooting episodes.",
        "bannerImage": "http://139.59.37.14:4200/uploads/1779881862212-Movo_db_new.webp",
        "websiteUrl": "https://myoutdoortv.com/",
        "technologies": [
          {
            "name": "Swift",
            "icon": "http://139.59.37.14:4200/uploads/1779881863309-swift.webp"
          }
        ],
        "priority": 1,
        "platforms": "Mobile",
        "category": "Non-Gov",
        "subCategory": "Fitness",
        "projectImages": [],
        "projectOverview": ""
      },
      {
        "title": "NEOU (3)",
        "year": 2018,
        "status": "live",
        "description": "Discover the NEW YOU with at-home and on-the-go fitness reimagined!",
        "bannerImage": "http://139.59.37.14:4200/uploads/1779882419952-Neou App Banner.webp",
        "websiteUrl": "https://neoufitness.com/",
        "technologies": [
          {
            "name": "Design",
            "icon": "http://139.59.37.14:4200/uploads/1779882420835-figma.webp"
          }
        ],
        "priority": 1,
        "platforms": "Mobile",
        "category": "Non-Gov",
        "subCategory": "Fintech",
        "projectImages": [],
        "projectOverview": ""
      },
      {
        "title": "Ease My Trip (3)",
        "year": 2018,
        "status": "live",
        "description": "EaseMyTrip is a booking application, which is for the guaranteed best price on travel.",
        "bannerImage": "http://139.59.37.14:4200/uploads/1779882076343-ease_my_trip_new.webp",
        "websiteUrl": "http://www.easemytrip.com/",
        "technologies": [
          {
            "name": "Swift",
            "icon": "http://139.59.37.14:4200/uploads/1779882077211-swift.webp"
          }
        ],
        "priority": 1,
        "platforms": "Mobile",
        "category": "Non-Gov",
        "subCategory": "Fintech",
        "projectImages": [],
        "projectOverview": ""
      },
      {
        title: "Imwow (3)",
        slug: "imwow-3",
        year: 2026,
        status: "live",
        description: "Imwow is a health and fitness project.",
        bannerImage:
          "http://139.59.37.14:4200/uploads/1779878108234-Screenshot 2026-05-27 115349.png",
        websiteUrl: "https://www.imwow.co.in/",
        technologies: [
          {
            name: "React Native",
            icon: "http://139.59.37.14:4200/uploads/1779878108544-rwacticon.webp",
          }
        ],
        priority: 1,
        platforms: "Mobile",
        category: "Non-Gov",
        subCategory: "Fitness",
        projectImages: [],
        projectOverview: "",
      }
    ],
    upcomingProjects: [
      {
        title: "Test App",
        slug: "imwow-upcoming",
        year: 2026,
        status: "upcoming",
        description: "Imwow is a health and fitness project.",
        bannerImage: "http://139.59.37.14:4200/uploads/1779878680119-Screenshot 2026-05-27 115349.png",
        websiteUrl: "https://www.imwow.co.in/",
        technologies: [
          {
            "name": "React Native",
            "icon": "http://139.59.37.14:4200/uploads/1779878682611-rwacticon.webp"
          },
          {
            "name": "Typescript",
            "icon": "http://139.59.37.14:4200/uploads/1779878682654-typescript.webp"
          }
        ],
        priority: 1,
        platforms: "Mobile",
        category: "Non-Gov",
        subCategory: "Fitness",
        projectImages: [
          "http://139.59.37.14:4200/uploads/1779878680686-siraj-alam-cm4G9l8tGnI-unsplash.jpg",
          "http://139.59.37.14:4200/uploads/1779878680871-jyoti-singh-evtL96IfR2E-unsplash.jpg",
          "http://139.59.37.14:4200/uploads/1779878681152-chad-madden-SUTfFCAHV_A-unsplash.jpg"
        ],
        projectOverview: "<p><strong>ADDENDUM NO. 1</strong></p><p><strong>to the Service Agreement dated 5.6.2024 („Service Agreement“)<br>between<br>Etulintu s.r.o., with offices at Ondříčkova 1270/25, Žižkov, 130 00 Prague 3, Czech Republic (“Client”)</strong></p><p><strong><br>and</strong></p><p><strong><br>Tycho Technologies PVT LTD, Office no. B02 H, 182, Sector 63 Rd, H Block, Sector 63, Noida, Uttar Pradesh 201301, India (“Developer”)</strong></p><p><strong>Purpose</strong><br>To address project delays and quality concerns, define clear deliverables and milestones, and agree on updated financial and oversight terms.</p><p><strong>1. Background</strong></p><p>1.1 The Parties held videoconferences on Monday, September 8, 2025 and Monday September 22, 2025, during which they agreed to modify and extend their cooperation as set forth in the existing Services Agreement entered into between the Parties.</p><p>1.2 The Parties wish to record these modifications and extensions in this Addendum, which shall form an integral part of the Agreement.</p><ol><li><strong>Scope of Deliverables (Core Pillars)</strong></li></ol><p>1.1 The Parties agree that in order to reduce risk and simplify the impediment of the  technical issues that arose during the project concerning the <strong>core search functionality</strong> of the platform, that it will be switched from <em>Tour Destination Search</em> to <em>Map Search</em>.</p><ul><li>The previously considered AWS geolocation switch at the “Create Tour” point in the Guide applications shall be abandoned.</li><li>The Map Search update will include a UI/UX update of the Visitor application, in accordance with the updated Customer Journey document attached as Annex 1 hereto.</li><li>For avoidance of doubt, the Customer Journey document, attached in Annex 1 hereto, shall take precedence if there are any conflicting instructions with any previous documentation, including the System Description, which otherwise still holds as the main defining document of the project to be delivered under the Service Agreement. </li></ul><p>1.2 In addition, the following <strong>functional extensions</strong> are agreed:<br>(a) <strong>Backend applications:</strong></p><ul><li>Reviewer application: text boxes shall be made editable.</li><li>Guides shall be able to take their own tours free of charge to check them as finished products (with possible overlap of work with the Visitor application).</li><li>Super Admin application: addition of a default parameter adjustment page.</li><li>All backend applications: in order to tidy up and reach agreed upon functionality, some minor adjustments may be required in the process. </li></ul><ul><br></ul><ul><br></ul><p><strong></strong><br></p><ul><li><ul><li><br></li><br></ul><br></li><li><strong></strong><br></li></ul>"
      }
    ]
  }
};

